export default function ErrorDialog({
  isOpen,
  error,
  onClose,
  onRetry,
  existingApplicationData,
}) {
  if (!isOpen) return null;
  console.log(error);

  const is413Error = error?.response?.status === 413;
  const is400Error = error?.response?.status === 400;
  const isAlreadyExists =
    is400Error &&
    (error?.response?.data?.alreadyExists === true ||
      error?.response?.data?.message
        ?.toLowerCase()
        .includes("already exists") ||
      error?.response?.data?.message?.toLowerCase().includes("duplicate"));

const getErrorMessage = () => {
  if (is413Error) return "File Too Large";
  if (isAlreadyExists) return "Application Already Exists";
  if (typeof error === "string") return error;
  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.message) return error.message;
  return "Failed to submit";
};

  const getErrorDetails = () => {
    if (is413Error) return "Please make sure all files are under 1MB.";
    if (isAlreadyExists)
      return "You already have an application with this information.";
    return "Please try again or contact support if the problem continues.";
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-container" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          className="close-button"
          onClick={onClose}
          aria-label="Close dialog"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        {/* Header */}
        <div className="dialog-header">
          <div className="status-icon error">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                stroke="currentColor"
                strokeWidth="2"
              />
              <path
                d="M12 8V12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M12 16H12.01"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h3 className="dialog-title">{getErrorMessage()}</h3>
          <p className="dialog-description">{getErrorDetails()}</p>
        </div>

        {/* Existing Application Info */}
        {isAlreadyExists && existingApplicationData && (
          <div className="info-card">
            <div className="info-header">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="info-icon"
              >
                <path
                  d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
              <span>Existing Application</span>
            </div>
            <div className="info-content">
              {existingApplicationData.applicationId && (
                <div className="info-item">
                  <span className="info-label">Application ID:</span>
                  <span className="info-value">
                    {existingApplicationData.applicationId}
                  </span>
                </div>
              )}
              {existingApplicationData.status && (
                <div className="info-item">
                  <span className="info-label">Status:</span>
                  <span
                    className={`status-tag ${existingApplicationData.status.toLowerCase()}`}
                  >
                    {existingApplicationData.status}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="dialog-actions">
          {isAlreadyExists ? (
            <>
           
            </>
          ) : (
            <button
              className="btn btn-primary btn-center"
              onClick={() => {
                onClose();
                if (!is413Error && onRetry) onRetry();
              }}
            >
              {is413Error ? "OK" : "Try Again"}
            </button>
          )}
        </div>
      </div>

      <style jsx>{`
        .dialog-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 16px;
          animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .dialog-container {
          background: #ffffff;
          border-radius: 24px;
          padding: 40px;
          max-width: 480px;
          width: 100%;
          box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2),
            0 8px 24px rgba(0, 0, 0, 0.12);
          border: 1px solid rgba(255, 255, 255, 0.9);
          animation: scaleIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
        }

        .close-button {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 36px;
          height: 36px;
          border-radius: 10px;
          border: none;
          background: #f1f5f9;
          color: #64748b;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          z-index: 10;
        }

        .close-button:hover {
          background: #e2e8f0;
          color: #334155;
          transform: rotate(90deg);
        }

        .close-button:active {
          transform: rotate(90deg) scale(0.95);
        }

        .close-button svg {
          width: 18px;
          height: 18px;
        }

        .dialog-header {
          text-align: center;
          margin-bottom: 24px;
        }

        .status-icon {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 72px;
          height: 72px;
          border-radius: 50%;
          margin-bottom: 20px;
          position: relative;
        }

        .status-icon.error {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          color: #dc2626;
          box-shadow: 0 8px 24px rgba(220, 38, 38, 0.15),
            0 0 0 8px rgba(220, 38, 38, 0.05);
          animation: pulse 2s ease-in-out infinite;
        }

        .status-icon svg {
          width: 36px;
          height: 36px;
          filter: drop-shadow(0 2px 4px rgba(220, 38, 38, 0.1));
        }

        .dialog-title {
          font-size: 26px;
          font-weight: 700;
          color: #0f172a;
          margin: 0 0 12px;
          line-height: 1.3;
          letter-spacing: -0.02em;
        }

        .dialog-description {
          font-size: 16px;
          color: #64748b;
          line-height: 1.6;
          margin: 0;
        }

        .info-card {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border: 1.5px solid #e2e8f0;
          border-radius: 16px;
          padding: 24px;
          margin-bottom: 28px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          transition: all 0.3s ease;
        }

        .info-card:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border-color: #cbd5e1;
        }

        .info-header {
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 600;
          color: #475569;
          margin-bottom: 12px;
          font-size: 15px;
        }

        .info-icon {
          width: 18px;
          height: 18px;
          color: #64748b;
        }

        .info-content {
          space-y: 8px;
        }

        .info-item {
          display: flex;
          justify-content: between;
          align-items: center;
          padding: 4px 0;
        }

        .info-label {
          font-weight: 500;
          color: #64748b;
          font-size: 14px;
          min-width: 120px;
        }

        .info-value {
          color: #1e293b;
          font-weight: 500;
          font-size: 14px;
        }

        .status-tag {
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 500;
          text-transform: capitalize;
        }

        .status-tag.pending {
          background: #fef3c7;
          color: #d97706;
        }

        .status-tag.approved {
          background: #d1fae5;
          color: #059669;
        }

        .status-tag.rejected {
          background: #fee2e2;
          color: #dc2626;
        }

        .status-tag:not(.pending):not(.approved):not(.rejected) {
          background: #f3f4f6;
          color: #6b7280;
        }

        .dialog-actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
        }

        .dialog-actions:has(.btn-center) {
          justify-content: center;
        }

        .btn {
          border: none;
          border-radius: 12px;
          padding: 14px 28px;
          font-weight: 600;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          min-width: 110px;
          letter-spacing: -0.01em;
        }

        .btn-primary {
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
          color: #fff;
          box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3),
            0 2px 4px rgba(37, 99, 235, 0.2);
        }

        .btn-primary:hover {
          background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(37, 99, 235, 0.4),
            0 4px 8px rgba(37, 99, 235, 0.2);
        }

        .btn-primary:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
        }

        .btn-outline {
          background: #ffffff;
          color: #64748b;
          border: 2px solid #e2e8f0;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .btn-outline:hover {
          background: #f8fafc;
          color: #334155;
          border-color: #cbd5e1;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
          transform: translateY(-1px);
        }

        .btn-outline:active {
          transform: translateY(0);
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.92) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        /* Responsive design */
        @media (max-width: 480px) {
          .dialog-container {
            padding: 24px;
            margin: 16px;
          }

          .dialog-actions {
            flex-direction: column-reverse;
          }

          .btn {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
}
